export const DRAFT_DISCLAIMER = 'Draft for review. Not legal advice. Have a lawyer check before you register.';
const en = {
    title: 'Leave and license agreement (draft)',
    disclaimer: DRAFT_DISCLAIMER,
    grant: (licensor, licensee, address, use) => `The Licensor ${licensor} grants the Licensee ${licensee} a licence to use the premises at ${address} for ${use} purposes.`,
    term: (months, start) => `The term is ${String(months)} months from ${start}.`,
    fee: (rent, deposit) => `The licence fee is ${rent} per month, with a refundable security deposit of ${deposit}.`,
    escalation: (percent) => `The licence fee increases by ${String(percent)} percent on renewal.`,
    noEscalation: 'There is no escalation within the term.',
    lockIn: (months, days) => `Lock in period: ${String(months)} months. Notice period: ${String(days)} days.`,
    estimateHeading: 'Stamp duty and registration estimate',
    estimateNote: '',
    rulesVersion: (version) => `rule version ${version}`,
    stampDuty: 'Stamp duty (estimate)',
    registrationFee: 'Registration fee (estimate)',
    handling: 'Document handling (estimate)',
    total: 'Total (estimate)',
    reviewMessage: (agency, property, link) => `${agency}: here is the draft agreement for ${property}, to read. It is a draft, it is not signed, and it is not legal advice. The stamp duty and registration figures are an estimate. Open it here: ${link}`,
};
const mr = {
    title: 'लीव्ह अँड लायसन्स करार (मसुदा)',
    disclaimer: 'पुनरावलोकनासाठी मसुदा. हा कायदेशीर सल्ला नाही. नोंदणी करण्यापूर्वी वकिलाकडून तपासून घ्या.',
    grant: (licensor, licensee, address, use) => `लायसन्सर ${licensor} हे लायसन्सी ${licensee} यांना ${address} येथील जागा ${use} वापरासाठी वापरण्याचा परवाना देतात.`,
    term: (months, start) => `कालावधी ${start} पासून ${String(months)} महिने आहे.`,
    fee: (rent, deposit) => `लायसन्स फी दरमहा ${rent} आहे आणि परत मिळणारी सुरक्षा अनामत रक्कम ${deposit} आहे.`,
    escalation: (percent) => `नूतनीकरणाच्या वेळी लायसन्स फी ${String(percent)} टक्क्यांनी वाढेल.`,
    noEscalation: 'कराराच्या कालावधीत कोणतीही वाढ नाही.',
    lockIn: (months, days) => `लॉक-इन कालावधी: ${String(months)} महिने. नोटीस कालावधी: ${String(days)} दिवस.`,
    estimateHeading: 'मुद्रांक शुल्क आणि नोंदणी यांचा अंदाज',
    estimateNote: 'अंदाज. IGR कॅल्क्युलेटरवर तपासा',
    rulesVersion: (version) => `नियम आवृत्ती ${version}`,
    stampDuty: 'मुद्रांक शुल्क (अंदाज)',
    registrationFee: 'नोंदणी शुल्क (अंदाज)',
    handling: 'कागदपत्र हाताळणी (अंदाज)',
    total: 'एकूण (अंदाज)',
    reviewMessage: (agency, property, link) => `${agency}: ${property} साठीचा कराराचा मसुदा वाचण्यासाठी येथे आहे. हा मसुदा आहे, त्यावर सही झालेली नाही आणि हा कायदेशीर सल्ला नाही. मुद्रांक शुल्क आणि नोंदणीचे आकडे अंदाज आहेत. येथे उघडा: ${link}`,
};
const hi = {
    title: 'लीव एंड लाइसेंस अनुबंध (मसौदा)',
    disclaimer: 'समीक्षा के लिए मसौदा। यह कानूनी सलाह नहीं है। पंजीकरण से पहले किसी वकील से जँचवा लें।',
    grant: (licensor, licensee, address, use) => `लाइसेंसदाता ${licensor} लाइसेंसधारी ${licensee} को ${address} स्थित परिसर ${use} उपयोग के लिए इस्तेमाल करने का लाइसेंस देते हैं।`,
    term: (months, start) => `अवधि ${start} से ${String(months)} महीने है।`,
    fee: (rent, deposit) => `लाइसेंस शुल्क ${rent} प्रति माह है, और वापसी योग्य सुरक्षा जमा राशि ${deposit} है।`,
    escalation: (percent) => `नवीनीकरण पर लाइसेंस शुल्क ${String(percent)} प्रतिशत बढ़ेगा।`,
    noEscalation: 'अवधि के दौरान कोई वृद्धि नहीं होगी।',
    lockIn: (months, days) => `लॉक-इन अवधि: ${String(months)} महीने। नोटिस अवधि: ${String(days)} दिन।`,
    estimateHeading: 'स्टांप शुल्क और पंजीकरण का अनुमान',
    estimateNote: 'अनुमान। IGR कैलकुलेटर पर जाँचें',
    rulesVersion: (version) => `नियम संस्करण ${version}`,
    stampDuty: 'स्टांप शुल्क (अनुमान)',
    registrationFee: 'पंजीकरण शुल्क (अनुमान)',
    handling: 'दस्तावेज़ संभाल (अनुमान)',
    total: 'कुल (अनुमान)',
    reviewMessage: (agency, property, link) => `${agency}: ${property} के अनुबंध का मसौदा पढ़ने के लिए यह है। यह मसौदा है, इस पर हस्ताक्षर नहीं हुए हैं, और यह कानूनी सलाह नहीं है। स्टांप शुल्क और पंजीकरण के आँकड़े अनुमान हैं। इसे यहाँ खोलें: ${link}`,
};
const STRINGS = { en, mr, hi };
export const agreementStrings = (lang = 'en') => STRINGS[lang];
//# sourceMappingURL=agreement-text.js.map